export const OverallDryingRatingAttributeNames = [
  "dryingDuration",
  "dryingProcess",
  "knowledgeGain",
] as const;

export type OverallDryingRatingAttribute = typeof OverallDryingRatingAttributeNames[number];
export type OverallDryingRating = {
  [Attribute in OverallDryingRatingAttribute]: number | null;
};
